import React, { useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

import NavBarSkeleton from './NavBarSkeleton';

const NavigationBar = ({ categorys, onCategoryChange, onSearch, category, loading }) => {
  const [searchInput, setSearchInput] = useState('');

  const prevArrowRef = useRef(null);
  const nextArrowRef = useRef(null);

  const slider = useRef();

  const handleSearchInputChange = e => {
    setSearchInput(e.target.value);
  };

  const handleSearch = () => {
    onSearch(searchInput);
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  useEffect(() => {
    if (slider.current && prevArrowRef.current && nextArrowRef.current) {
      prevArrowRef.current.onclick = () => slider.current.slickPrev();
      nextArrowRef.current.onclick = () => slider.current.slickNext();
    }
  }, []);

  const skeletons = Array.from({ length: 5 }, (_, index) => <NavBarSkeleton key={index} />);

  const settings = {
    speed: 300,
    swipe: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    variableWidth: true,
    nextArrow: <div ref={nextArrowRef}></div>,
    prevArrow: <div ref={prevArrowRef}></div>,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="bg-white max-w-[1200px] w-full md:flex hidden relative rounded-[50px] overflow-hidden">
      <style>
        {`
          .slick-track {
            display: flex;
           gap: 10px;
          }
        `}
      </style>

      <div className="md:flex hidden w-full py-[14px] bg-white ">
        <div className="container">
          <div className="flex justify-between items-center gap-[16px]">
            <button className="absolute lg:left-[20px] left-0 top-[30px] mr-[5px]" ref={prevArrowRef}>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.94141 10.115L8.05641 11L3.05641 6L8.05641 1L8.94141 1.885L4.82641 6L8.94141 10.115Z" fill="#979797" />
              </svg>
            </button>
            <div className="flex justify-center items-center lg:max-w-[70%] max-w-[60%] w-full">
              {loading ? (
                <>{skeletons}</>
              ) : (
                <Slider ref={slider} {...settings} className=" w-full">
                  {categorys.map((item, index) => (
                    <p
                      className={`text-[16px] mr-[25px] font-[500] leading-[20px] whitespace-nowrap ${category === item.label ? 'text-[#0052B4]' : ''}`}
                      key={index}
                    >
                      <span className="cursor-pointer" onClick={() => onCategoryChange(item.label)}>
                        {item.label}{' '}
                      </span>
                    </p>
                  ))}
                </Slider>
              )}
            </div>
            <button ref={nextArrowRef}>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.05859 10.115L3.94359 11L8.94359 6L3.94359 1L3.05859 1.885L7.17359 6L3.05859 10.115Z" fill="#979797" />
              </svg>
            </button>
            <div className="flex justify-items-center items-center">
              <input
                type="text"
                placeholder="Enter Keywords to Search"
                onChange={handleSearchInputChange}
                onKeyDown={handleKeyPress}
                className="text-[12px] font-[400] leading-[15px] w-[300px] py-[13px] px-[16px] bg-[#EEEAF9] focus:outline-none focus:placeholder-transparent rounded-[50px]"
              />
              <button onClick={handleSearch} className="bg-white rounded-[5px] p-[6px] absolute lg:right-[50px] right-[30px]">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.474 9.28499H9.84854L9.62687 9.07124C10.4027 8.16874 10.8698 6.99708 10.8698 5.72249C10.8698 2.88041 8.56604 0.57666 5.72396 0.57666C2.88188 0.57666 0.578125 2.88041 0.578125 5.72249C0.578125 8.56458 2.88188 10.8683 5.72396 10.8683C6.99854 10.8683 8.17021 10.4012 9.07271 9.62541L9.28646 9.84708V10.4725L13.2448 14.4229L14.4244 13.2433L10.474 9.28499ZM5.72396 9.28499C3.75271 9.28499 2.16146 7.69374 2.16146 5.72249C2.16146 3.75124 3.75271 2.15999 5.72396 2.15999C7.69521 2.15999 9.28646 3.75124 9.28646 5.72249C9.28646 7.69374 7.69521 9.28499 5.72396 9.28499Z"
                    fill="#979797"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationBar;
